import { useCallback, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { MiCard, MiChip } from "@miplatform/components";
import {
  ATTEMPT_STATUSES,
  BUTTON_COLORS,
  BUTTON_VARIANTS,
} from "@miplatform/constants";
import { getContrastColor } from "@miplatform/utils";
import { mdiChevronDown, mdiChevronUp } from "@mdi/js";
import { Footer } from "@mibuildweb/components";
import { Box } from "@mui/material";
import { IssueCard } from "../../../IssueCard/IssueCard";

const StatusCards = ({ assignment = {}, issues = [] }) => {
  const {
    order: { orderTemplateColor, orderTemplateAbbreviation } = {},
    assignmentNumber,
  } = assignment;

  const { classes, theme } = useStyles();
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);

  return (
    <Box>
      <MiCard
        title={`Current Order: #${assignmentNumber}`}
        customLeftIcon={
          <MiChip
            className={classes.chip}
            style={{
              backgroundColor: orderTemplateColor,
              color: getContrastColor(orderTemplateColor),
            }}
            label={orderTemplateAbbreviation}
            size="small"
          />
        }
        containerStyles={{
          padding: theme.spacing(2),
          marginTop: theme.spacing(2),
          border: `1px solid ${theme.palette.green.main}`,
          borderRadius: theme.spacing(1),
        }}
        onRightIconClick={() => setIsAccordionOpen((prev) => !prev)}
        rightIcon={isAccordionOpen ? mdiChevronUp : mdiChevronDown}
      >
        {isAccordionOpen && (
          <Box className={classes.cardsContainer}>
            {issues.map((issue, i) => {
              return (
                <IssueCard key={issue.id} issue={issue} issueIndex={i + 1} />
              );
            })}
          </Box>
        )}
      </MiCard>
    </Box>
  );
};

export const Review = ({
  attempt,
  onCancel,
  closeoutAttempt,
  isWoReviewed,
  onEmailDrawerOpen,
}) => {
  const { classes } = useStyles();

  const getActions = useCallback(() => {
    const actions = [
      {
        name: "Cancel",
        variant: BUTTON_VARIANTS.TEXT,
        color: BUTTON_COLORS.BLACK,
        onClick: onCancel,
      },
    ];

    if (attempt.attemptStatus === ATTEMPT_STATUSES.CLOSEOUT_IN_PROGRESS) {
      actions.push({
        name: "Start Email",
        variant: BUTTON_VARIANTS.CONTAINED,
        onClick: onEmailDrawerOpen,
      });
    }

    return actions;
  }, [onCancel, closeoutAttempt, isWoReviewed, attempt]);

  return (
    <Box className={classes.root}>
      <Box className={classes.issueContainer}>
        <StatusCards assignment={attempt.assignment} issues={attempt.issues} />
      </Box>
      <Footer show actions={getActions()} />
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  root: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  title: {
    ...theme.typography.body1,
    fontWeight: theme.typography.fontWeightBold,
  },
  cardsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  cardTitle: {
    ...theme.typography.body2,
    fontWeight: theme.typography.fontWeightBold,
  },
  issueContainer: {
    overflowY: "auto",
    flex: 1,
  },
  fieldsets: {
    ...theme.typography.body2,
    color: theme.palette.grey.main,
  },
  chip: {
    borderRadius: theme.spacing(0.5),
    minWidth: 18,
    height: 18,
    fontSize: theme.fontSize.xxsmall,
    fontWeight: theme.fontWeight.semiBold,
    "& .MuiChip-label": {
      padding: 0,
    },
  },
}));
